/* eslint react/no-string-refs: "off" */

import React from 'react';
import _ from 'lodash';

import FieldTreeConstructor from '../components/FieldTreeConstructor';
import FieldTreeCompany from '../components/FieldTreeCompany';
import FieldTreeNewBlock from '../components/FieldTreeNewBlock';
import FieldTreeLabel from '../components/FieldTreeLabel';
import masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import fetchMg from '../utilities/fetchManager';
import EventMg, { EventType } from '../utilities/EventManager';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import { JvCompanyDropdown } from './dropdowns/single/JvFieldTreeCompanyBranch';
import * as dialog from '../components/FieldTreeDialog';
import { PartnerCompanyAddDialog } from '../components/PartnerCompanyAddDialog';
import * as api from '../services/FieldTree';
import FieldTreeService from '../services/FieldTrees';
import FieldTreesApi from '../services/fieldTrees/FieldTreesApi';
import LocalStorageService from '../services/utilities/LocalStorageService';
import {
  USER_ROLES,
  JOINING_FLAG,
  PARTNER_COMPANY_REGISTER_LOAD_FROM,
  CALL_FROM_PAGE,
  FINISH_FLAG,
  STATUS_CODE,
  UNFINISH_TYPE,
  ENTER_WORKER_FIELD_TREE_ID_PARAM_NAME,
  APPROVAL_STATUS_FIELDTREE,
} from '../utilities/constants';
import { Modal } from './Modal';
import { DialogSuccessError } from './modals/DialogSuccessError';
import { messageUtility } from '../utilities/messageUtility';
import FieldTreePagination from '../components/FieldTreePagination';
import Information from '../components/modals/common/Information';
import { convertPostalCode } from '../utilities/stringUtil';
import { HEAD_OFFICE_OPTION } from './PartnerCompanyBranchDropdown';
import { AddPartnerCompanyFieldTreeSuccessDialog } from './FieldTreeDialog';
import { Confirmation } from './modals/common';
import { updateFinishFlagFieldTree } from '../services/FieldTree';
import {
  isApiFlagOn,
  getQueryStringParameter,
  redirectToGreenfileSagyouinEditIfFromGreenfile,
} from '../utilities/commonUtil';
import Switch from './Switch';
import { QuestionIcon } from './icons/QuestionIcon';
import Tippy from '../components/ReactTippy';
import SessionStorageService from '../services/utilities/SessionStorageService';

class FieldTree extends React.Component {
  constructor(props) {
    super(props);
    this.path = '0';
    this.newMenuRef = null;
    this.fieldTree = null;
    this.role_id = LocalStorageService.getRoleId();
    this.updatingFlag = false; // 連打防止
    this.isSubmitingFlag = false;
    this.state = {
      branchOfCompaniesDictioanry: null,
      jv: null,
      jvflag: false,
      jvcompanybranch: [],
      visibleDialogFlag: false,
      errorMessage: '',
      visiblePartnerReportsCreatedConfirmDialog: false,
      visibleCheckPartnerReportsCreatedErrorDialog: false,
      hasPartners: false,
    };

    //絞り込みクリア
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_CLEAR_SEARCH_PARAM, () => {
      // this.JVSelectRef && this.JVSelectRef.resetValue();
    });

    // 元請BOXの"確認・編集"押下時
    EventMg.addEventListener(FIELD_TREE_EVENTS.CONSTRUCTOR_EDIT, (path, id) => {
      let param = {
        id,
        jvcbid: this.state.jv || this.props.constructor.id,
      };
      const json = encodeURIComponent(JSON.stringify(param));
      masterSlideLoader.show(
        'ContractorBox',
        { state: { id: json, tree: this.props.tree } },
        this.props.vw
      );
    });

    //作業員割り当て
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.COMPANY_WORKER_ASSIGNATION,
      (path, nodes) => {
        this.handleClickAssignation(nodes);
      }
    );

    // 協力会社BOXの"確認・編集"押下時
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.COMPANY_EDIT,
      async (path, nodes) => {
        if (nodes.permissions.partner_box_detail.show === false) {
          // エラーのダイアログ
          this.setState({
            showModal: true,
            // 実際はsuccessではないがボタンのため
            updateSuccess: true,
            updateMsg: messageUtility.getMessage('E-001-001'),
          });

          // 以降の処理を禁止
          return;
        }

        masterSlideLoader.show(
          'PartnerBox',
          {
            state: {
              id: nodes.id,
              tree: this.props.tree,
              node: nodes,
            },
          },
          '1'
        );
      }
    );

    /**
     * 元請BOX or 協力会社BOXの新規 => "登録データを検索して追加"押下時
     * optionsのパラメータ：
     * options.path: string | 現場体制の協力会社BOXのルート 例：'1-0-1' // 不要？
     * options.nodes: object | 協力会社BOXの会社情報
     * options.cacheParams: object | 検索パラメータ
     */
    EventMg.addEventListener(FIELD_TREE_EVENTS.NEW_SEARCH, async options => {
      if (_.isUndefined(options.nodes.company_branch_id)) {
        options.nodes.nest_no = 0;
      }

      if (options.nodes.permissions.partner_box.search_and_add === false) {
        // エラーのダイアログ
        this.setState({
          showModal: true,
          // 実際はsuccessではないがボタンのため
          updateSuccess: true,
          updateMsg: messageUtility.getMessage('E-001-001'),
        });

        // 以降の処理を禁止
        return;
      }
      let field_tree_id = null;
      let parentCompanyBranchId;
      let jvCompanyBranchId;
      if (options.nodes.constructor === true) {
        field_tree_id = 0;
        parentCompanyBranchId = options.nodes.id;
        jvCompanyBranchId = options.nodes.id;
      } else {
        field_tree_id = options.nodes.id;
        parentCompanyBranchId = options.nodes.company_branch_id;
        jvCompanyBranchId = options.nodes.prime_contractors_company_branch_id;
      }
      const myCompanyId = SessionStorageService.getCompanyId();
      const jvCompanyId = this.state.branchOfCompaniesDictioanry[
        jvCompanyBranchId
      ];
      const jvFieldTree = jvCompanyId !== _.toNumber(myCompanyId);

      dialogLoader.show(
        PartnerCompanyAddDialog,
        {
          state: {
            similarCompanyExists: false,
            permissions: options.nodes.permissions,
            options,
          },
          jvCompanyBranchId,
          jvCompanyId,
          parentCompanyBranchId,
          fieldId: this.props.fieldId,
          fieldTreeId: field_tree_id,
          jvFieldTree,
          loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.FIELD_TREE_PAGE,
          callback: {
            close: () => {
              // 登録をやめる
              dialogLoader.close();
              EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
              masterSlideLoader.show(
                'FieldTreePage',
                { state: { id: 1 } },
                this.props.vw
              );
              EventMg.trigger(FIELD_TREE_EVENTS.BACK_TO_MAIN, {
                update: true,
              });
            },
            create: () => {
              dialogLoader.close();
              masterSlideLoader.show('PartnerCompanyPersonalRegister', {
                state: {
                  field_id: this.props.fieldId,
                  field_tree_id,
                  jvCompanyBranchId,
                  jvFieldTree,
                  parent_company_branch_id: parentCompanyBranchId,
                  loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.FIELD_TREE_PAGE,
                  permissions: options.nodes.permissions,
                  options,
                },
              });
            },
            createCompany: data => {
              this.createCompany(data);
            },
            // 現場に追加ボタンを押下
            submit: (formValues, confirmValues, isPartners) => {
              if (this.updatingFlag) {
                return;
              } else {
                this.updatingFlag = true;
                const param = {
                  parent_tree_id: formValues.parent_tree_id,
                  private_partner_company_flag:
                    formValues.private_partner_company_flag,
                  work_hour_zone_day_flag: formValues.work_hour_zone_day_flag,
                  work_hour_zone_night_flag:
                    formValues.work_hour_zone_night_flag,
                  work_hour_zone_midnight_flag:
                    formValues.work_hour_zone_midnight_flag,
                  representative: formValues.representative,
                  prime_contractors_company_branch_id:
                    formValues.prime_contractors_company_branch_id,
                  company_branch_id: formValues.company_branch_id,
                  call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE,
                };

                const branchId = formValues.partner_company_branch_id;
                if (branchId && branchId !== HEAD_OFFICE_OPTION.id) {
                  param.partner_company_branch_id = branchId;
                }

                if (!isPartners) {
                  // 協力会社一覧にない場合は、協力会社一覧に登録も必要
                  const parentTreeId = field_tree_id;
                  const primeContractorsCompanyBranchId = jvCompanyBranchId;

                  this.confirmCreateFieldTree(
                    formValues,
                    confirmValues,
                    parentTreeId,
                    primeContractorsCompanyBranchId
                  );
                } else {
                  FieldTreesApi.create(formValues.field_id, param)
                    .then(response => {
                      if (response.result) {
                        const fieldTree = _.get(
                          response,
                          'data.entities.field_tree'
                        );
                        dialogLoader.show(
                          AddPartnerCompanyFieldTreeSuccessDialog,
                          {
                            companyName: fieldTree.company_name,
                            onConfirm: () => {
                              dialogLoader.close();
                              masterSlideLoader.show('PartnerBox', {
                                state: { id: fieldTree.id },
                              });
                            },
                            onCancel: () => {
                              dialogLoader.close();
                              EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
                            },
                          }
                        );
                      } else {
                        this.showErrorDialog(response.data.message);
                      }
                    })
                    .finally(() => {
                      this.updatingFlag = false;
                    });
                }
              }
            },
          },
        },
        this.props.vw
      );
    });

    //新規メニューのREF
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_NEWMENU_REF, ref => {
      this.newMenuRef = ref || null;
    });

    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_CLICK_OUTSIDE_TREE, e => {
      if (!this.newMenuRef) {
        return;
      } else {
        if (this.newMenuRef.contains(e.target)) {
          return;
        }
      }
      this.removeAllNewBlock();
      this.forceUpdate();
    });

    // 元請BOX or 協力会社BOXの新規 => "会社情報を代理入力して追加"押下時
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.NEW_BY_FORM,
      async (path, nodes) => {
        // 元請け会社の場合（元請けはcompany_branch_idがundefinedになる）
        if (_.isUndefined(nodes.company_branch_id)) {
          // 元請け会社のnest_noは0に設定する
          nodes.nest_no = 0;
        }

        if (nodes.permissions.partner_box.proxy_register === false) {
          // エラーのダイアログ
          this.setState({
            showModal: true,
            // 実際はsuccessではないがボタンのため
            updateSuccess: true,
            updateMsg: messageUtility.getMessage('E-001-001'),
          });

          // 以降の処理を禁止
          return;
        }

        const param = {
          id: 0,
          fid: this.props.fieldId,
          ftid: nodes.id,
          cbid: nodes.company_branch_id,
          crid: this.props.constructor.id,
          ppcf: nodes.private_partner_company_flag,
          cst: path == '0-0-0' ? true : false,
          nno: nodes.nest_no,
        };
        const json = encodeURIComponent(JSON.stringify(param));
        //slideLoader.show(
        masterSlideLoader.show(
          'PartnerCompanyFormRegister',
          { state: { id: json } },
          this.props.vw
        );
      }
    );

    // アコーディオンメニュー => 施工体制の削除
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.COMPANY_DELETE,
      (fieldTree, canDelete) => {
        this.fieldTree = fieldTree;
        if (canDelete) {
          dialogLoader.show(dialog.DeletePartnerCompany, {
            callback: {
              back: () => {
                dialogLoader.close();
              },
              delete: () => this.handleDeleteCompany(fieldTree.id),
            },
          });
        } else {
          dialogLoader.show(dialog.NotAuthorityDelete, {
            approval_flag: fieldTree.approval_flag,
            callback: {
              close: () => {
                dialogLoader.close();
              },
            },
          });
        }
      }
    );

    // アコーディオンメニュー => 施工体制の作業終了
    EventMg.addEventListener(FIELD_TREE_EVENTS.COMPANY_DONE, node => {
      dialogLoader.show(dialog.ConfirmFinishWork, {
        callback: {
          back: () => {
            dialogLoader.close();
          },
          done: () => {
            this.workFinish(node.id, () => {
              dialogLoader.close();
              EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
              EventMg.trigger(FIELD_TREE_EVENTS.COMPANY_DONE_SUCCESS, node);
            });
          },
        },
      });
    });

    // アコーディオンメニュー => 作業終了取り消す
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.COMPANY_DONE_CANCEL,
      (fieldTreeId, parentFinishFlag, isLastChild) => {
        if (isApiFlagOn(parentFinishFlag)) {
          //Cannot CancelFinish work when parent is still finished
          dialogLoader.show(dialog.FieldTreeUpdateFinishFlagFailure, {
            callback: {
              done: () => {
                dialogLoader.close();
                EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
              },
            },
            title: messageUtility.getMessage('E-001-420'),
            message: messageUtility.getMessage('E-001-421'),
          });
          return;
        }
        dialogLoader.show(dialog.ConfirmCancelFinishWork, {
          callback: {
            back: () => {
              dialogLoader.close();
            },
            done: (doCancelAll = false) => {
              this.workFinishCancel(fieldTreeId, doCancelAll, () => {
                dialogLoader.close();
                EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
              });
            },
          },
          isLastChild,
        });
      }
    );
  }

  componentDidMount() {
    this.getJVList();
    if (this.props.cacheParam !== null) {
      this.showAddCompanyDialogWithSearch();
    }
    const nodeFieldTreeId = getQueryStringParameter(
      ENTER_WORKER_FIELD_TREE_ID_PARAM_NAME
    );
    if (nodeFieldTreeId) {
      FieldTreeService.showTree(this.props.fieldId, nodeFieldTreeId).then(
        response => {
          const nodes = _.get(response, 'data.entities.field_tree');
          if (nodes) {
            this.handleClickAssignation(nodes);
          }
        }
      );
    }
  }

  showAddCompanyDialogWithSearch = () => {
    const options = {
      cacheParam: this.props.cacheParam,
      path: '',
      nodes: this.props.nodes,
    };
    EventMg.trigger(FIELD_TREE_EVENTS.NEW_SEARCH, options);
  };

  submitCompany = (path, nodes, args) => {
    const param = {
      id: args[2].id,
      fid: this.props.fieldId,
      ftid: nodes.id,
      cbid: args[2].company_branch.id,
      crid: this.props.constructor.id,
      cst: path == '0-0-0' ? true : false,
      nno: nodes.nest_no,
    };
    const json = encodeURIComponent(JSON.stringify(param));
    masterSlideLoader.show(
      'PartnerCompanyFormAdd',
      { state: { id: json } },
      this.props.vw
    );
    dialogLoader.close();
  };

  handleClickAssignation = nodes => {
    dialogLoader.show(dialog.EnterWorkerManager, {
      state: {
        field_id: nodes.field_id,
        field_tree_id: nodes.id,
        company: {
          company_branch_id: nodes.company_branch_id,
          company_name: nodes.company_name,
        },
        company_id: nodes.company_id,
        autoTaskActive: this.props.autoTaskActive,
        companySecededCcusFlag:
          this.props.ccusInfo.mainJvCcusSecededFlag &&
          this.props.ccusInfo.mainJvFlag,
        ccusSyncedStatus: nodes.ccus_synced_status,
        jvFlag: this.state.jvflag,
      },
      callback: {
        back: () => {
          dialogLoader.close();
          if (getQueryStringParameter(ENTER_WORKER_FIELD_TREE_ID_PARAM_NAME)) {
            // 労務安全から遷移してきた時の条件分岐
            redirectToGreenfileSagyouinEditIfFromGreenfile();
          } else {
            EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
          }
        },
        submit: () => {
          dialogLoader.close();
          this.handleClickJobAndPositionRegister(nodes);
          EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
        },
      },
    });
  };

  handleClickJobAndPositionRegister = nodes => {
    dialogLoader.show(dialog.JobAndPositionRegister, {
      state: {
        field_id: nodes.field_id,
        field_tree_id: nodes.id,
      },
      callback: {
        back: () => {
          dialogLoader.close();
          this.handleClickAssignation(nodes);
        },
        close: () => {
          dialogLoader.close();
          redirectToGreenfileSagyouinEditIfFromGreenfile();
        },
      },
    });
  };

  removeAllNewBlock = () => {
    let _tree = _.assign([], this.props.tree);
    const req = nodes => {
      if (_.has(nodes, 'children')) {
        let _new = _.filter(nodes.children, val => {
          return val.type == 'new';
        });
        if (_new.length) {
          nodes.children.shift();
        }
        _.each(nodes.children, _node => {
          req(_node);
        });
      }
    };

    //１次請け
    _.each(_tree, _node => {
      req(_node);
    });
  };

  sortCompany = tree => {
    // private_partner_company_flagで(別途)会社を作業終了会社の上に表示する
    // order_numberで協力会社並び順を反映して、元請けを一番に移動する
    // 元請判断は「company_name === undefined」だけだと不安なので修正必要かも
    return _.orderBy(
      tree,
      ['private_partner_company_flag', 'order_number'],
      ['asc', 'asc']
    ).sort(function(x, y) {
      return x.company_name === undefined
        ? -1
        : y.company_name === undefined
        ? 1
        : 0;
    });
  };

  /**
   * JV判定
   */
  getJVList = async () => {
    const data = await api.JVList(this.props.fieldId);
    if (data) {
      let jvcompanybranch = [];
      let branchOfCompaniesDictioanry = {};
      _.map(data.company, companybranches => {
        _.map(companybranches, (value, key) => {
          if (key === 'company_branch_id') {
            jvcompanybranch.push(value);
            branchOfCompaniesDictioanry[value] = companybranches.company_id;
          }
        });
      });
      this.setState({
        jvflag: data.company.length > 1 ? true : false,
        jvcompanybranch,
        branchOfCompaniesDictioanry,
      });
    }
  };

  //JV選択
  //まとめてチェックする
  selectJV = companyBranchId => {
    this.setState({ jv: companyBranchId }, () => {
      EventMg.trigger(
        EventType.SEARCH_PARAM,
        'jv_company_branch_id',
        companyBranchId
      );
    });
  };

  /* TODO: 処理が怪しいかもしれない
  /**
   * 配下の会社を判定
   * this.props.operatable_company=自分からみて配下の協力会社
   */
  operatable = node => {
    //協力会社ユーザー
    if (!this.props.login_user_contractor) {
      return false;
    }
    //職長以下＆（招待中or承認待）
    if (
      this.role_id >= USER_ROLES.foreman.id &&
      (node.approval_flag == 0 || node.approval_flag == 2)
    ) {
      return false;
    }
  };

  /**
   * 会社ブロックの生成
   *
   * @param {*} nodes
   * @param {string} path 0-0とかのツリーを示すパス
   * @param {boolean} parentPermissionToggleFinish permission toggle finish of parent node
   * @param {number} parentFinishFlag finish flag of parent node
   * @returns
   * @memberof FieldTree
   */
  generateBlock = (
    nodes,
    path,
    parentPermissionToggleFinish = false,
    parentFinishFlag
  ) => {
    let _path = path;
    const permissionToggleFinish = !!_.get(
      nodes,
      'permissions.partner_box_detail.toggle_finish'
    );

    // 元請け
    if (path === '0-0') {
      return (
        <div key={_path} path={_path}>
          <div className='fieldstree-block'>
            <FieldTreeConstructor
              data={this.props.constructor}
              path={_path}
              login_user_contractor={this.props.login_user_contractor}
              isCcusDisplayStateFlg={this.props.isCcusDisplayStateFlg}
            />
            <div className='fieldstree-children'>
              {' '}
              {_.map(nodes.children, (company, index) => {
                // 新規ブロック
                if (company.type == 'new') {
                  return (
                    <div
                      className='fieldstree-block-new-menu'
                      key={_path}
                      path={`${_path}-${index}`}
                    >
                      <FieldTreeNewBlock
                        path={`${_path}-${index}`}
                        nodes={this.props.constructor}
                        constructor={true}
                      />
                    </div>
                  );
                }
              })}
            </div>
            {this.state.jvflag && (
              <div className='fieldstree-tree__jv'>
                <div className='form-element sys-event-dropdown'>
                  <div className='form-element__element fieldstree-tree__jv-element'>
                    <JvCompanyDropdown
                      companyBranchId={this.props.companyBranchId}
                      ref={e => {
                        this.JVSelectRef = e;
                      }}
                      name='company_branch_id'
                      value={this.props.constructor.id}
                      set={(name, id) => {
                        this.selectJV(id);
                      }}
                      setkey='company_branch_id'
                      placeholder={`${this.props.constructor.company_name} ${this.props.constructor.name}`}
                      fieldId={this.props.fieldId}
                      resetSelectedPartnerCompanyBranch={
                        this.props.resetSelectedPartnerCompanyBranch
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          {this.state.hasPartners && (
            <FieldTreeCcusConnection
              {...this.props.ccusInfo}
              tree={this.props.tree}
            />
          )}
        </div>
      );
    } else {
      return (
        <div className='fieldstree-block' key={_path} path={_path}>
          <FieldTreeCompany
            path={_path}
            nodes={nodes}
            operatable={this.operatable(nodes)}
            login_user_contractor={this.props.login_user_contractor}
            data={this.state.jvcompanybranch}
            tree={this.props.tree}
            isCcusDisplayStateFlg={this.props.isCcusDisplayStateFlg}
            selectedNodes={this.props.selectedNodes}
            parentPermissionToggleFinish={parentPermissionToggleFinish}
            parentFinishFlag={parentFinishFlag}
            scrollFieldTreeMain={this.props.scrollFieldTreeMain}
            companySecededCcusFlag={
              this.props.ccusInfo.mainJvCcusSecededFlag &&
              this.props.ccusInfo.mainJvFlag
            }
          />
          <div className='fieldstree-children'>
            {' '}
            {_.map(this.sortCompany(nodes.children), (company, index) => {
              // 新規ブロック
              if (company.type == 'new') {
                return (
                  <div
                    className='fieldstree-block-new-menu'
                    key={_path}
                    path={`${_path}-${index}`}
                  >
                    <FieldTreeNewBlock
                      path={`${_path}-${index}`}
                      nodes={nodes}
                      constructor={false}
                    />
                  </div>
                );
              } else {
                return this.generateBlock(
                  company,
                  `${_path}-${index}`,
                  permissionToggleFinish,
                  nodes.finish_flag
                );
              }
            })}
          </div>
        </div>
      );
    }
  };

  /**
   * 施工体制の削除
   * https://v2-dev.buildee.jp/apidocs/public/field_trees/destroy.html
   * DELETE /api/private/fields/:field_id/field_trees/:id
   * @param {number} fieldTreeId: 削除対象の施工体制ID
   */
  deleteCompany = async fieldTreeId => {
    const data = await fetchMg
      .DeleteAjax(
        `/api/private/fields/${this.props.fieldId}/field_trees/${fieldTreeId}`,
        {}
      )
      .catch(e => {
        const message = _.has(e[0], 'responseJSON.message')
          ? e[0].responseJSON.message
          : '';
        return {
          result: false,
          message,
        };
      });
    if (data.result) {
      return true;
    } else {
      dialogLoader.close();
      dialogLoader.show(dialog.DeletePartnerCompanyFailure, {
        message: data.message,
        callback: {
          done: () => {
            dialogLoader.close();
          },
        },
      });
      return false;
    }
  };

  /**
   * 施工体制の作業終了
   *
   * @param {number} fieldTreeId: 施工体制ID
   * @param {function} func: 作業終了後のコールバック関数
   * */
  workFinish = async (fieldTreeId, func) => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const data = { finish_flag: FINISH_FLAG.complete.id };
    const res = await updateFinishFlagFieldTree(
      this.props.fieldId,
      fieldTreeId,
      data
    );
    this.isSubmitingFlag = false;
    if (res.result) {
      if (_.isFunction(func)) {
        func();
      }
    } else {
      let message = _.get(res, 'data.message');
      if (res.status === STATUS_CODE.forbidden) {
        //Show common message for Forbidden Error
        message = messageUtility.getMessage('E-000-055');
      }
      dialogLoader.close();
      dialogLoader.show(dialog.FieldTreeUpdateFinishFlagFailure, {
        callback: {
          done: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
          },
        },
        message,
      });
    }
  };

  /**
   * 施工体制の作業終了の取り消し
   *
   * @param {number} fieldTreeId: 施工体制ID
   * @param {boolean} doCancelAll: 「下位協力会社も一括で取り消す」のフラグ
   * @param {function} func: 作業終了取り消し後のコールバック関数
   * */
  workFinishCancel = async (fieldTreeId, doCancelAll, func) => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const data = {
      finish_flag: FINISH_FLAG.incomplete.id,
      unfinish_type: doCancelAll ? UNFINISH_TYPE.ALL : UNFINISH_TYPE.ONLY,
    };
    const res = await updateFinishFlagFieldTree(
      this.props.fieldId,
      fieldTreeId,
      data
    );
    this.isSubmitingFlag = false;
    if (res.result) {
      if (_.isFunction(func)) {
        func();
      }
    } else {
      let message = _.get(res, 'data.message');
      let title;
      if (res.status === STATUS_CODE.forbidden) {
        //Show common message for Forbidden Error
        message = messageUtility.getMessage('E-000-055');
      }
      if (message === messageUtility.getMessage('E-001-421')) {
        title = messageUtility.getMessage('E-001-420');
      }
      dialogLoader.close();
      dialogLoader.show(dialog.FieldTreeUpdateFinishFlagFailure, {
        callback: {
          done: () => {
            dialogLoader.close();
            EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
          },
        },
        title,
        message,
      });
    }
  };

  checkDuplicate = async (
    field_id,
    company_id,
    prime_contractors_company_branch_id
  ) => {
    const response = await FieldTreeService.checkDuplicate(field_id, {
      field_id,
      company_branch_id: company_id,
      prime_contractors_company_branch_id,
    });
    if (response && response.result) {
      if (response.data.entities.is_duplicate) {
        return true;
      } else {
        return false;
      }
    }
  };

  createCompany = data => {
    dialogLoader.close();
    masterSlideLoader.show('PartnerCompanyPersonalRegister', {
      state: {
        listData: data,
        loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.FIELD_TREE_PAGE,
      },
    });
  };

  // 協力会社一覧にない企業を追加 + 現場体制に追加
  confirmCreateFieldTree = (
    formValues,
    company,
    parentTreeId,
    primeContractorsCompanyBranchId
  ) => {
    const fieldId = this.props.fieldId;
    const params = {
      company: {
        name: formValues.name,
        kana: formValues.kana,
        postal_code: !_.isUndefined(formValues.postal_code)
          ? convertPostalCode(formValues.postal_code)
          : '',
        prefectures_code_id: formValues.prefectures_code_id,
        city_name: formValues.city_name,
        street_number: formValues.street_number,
        building_name: formValues.building_name,
        tel: formValues.tel,
        fax: formValues.fax,
        personal_flag: formValues.personal_flag, // 個人
        joining_flag: JOINING_FLAG.contractorInherent.id, // 未加入法人は0
      },
      company_id: 0, // 未加入法人の場合0
      parent_tree_id: parentTreeId,
      prime_contractors_company_branch_id: primeContractorsCompanyBranchId,
      representative: formValues.representative,
      work_hour_zone_day_flag: formValues.work_hour_zone_day_flag,
      work_hour_zone_night_flag: formValues.work_hour_zone_night_flag,
      work_hour_zone_midnight_flag: formValues.work_hour_zone_midnight_flag,
      private_partner_company_flag: formValues.private_partner_company_flag, // 別途業者
      // company_id: null // TODO: 法人会社の場合必要かもしれない
    };
    if (!_.isUndefined(company)) {
      params.company = {
        ...params.company,
        ...company.company,
      };
      // Buildee加入済みで自社の協力会社一覧にない場合
      params.company_id = _.has(company, 'company.id') ? company.company.id : 0;

      // 選択した会社情報がある場合、joining_flagは１ (PartnerCompanyRegisterと揃える)
      params.company.joining_flag = 1;
    }
    // 法人番号がある場合paramsに追加
    if (!_.isEmpty(formValues.company_number)) {
      params.company.company_number = formValues.company_number;
    }
    // 法人格がある場合paramsに追加
    if (!_.isUndefined(formValues.juridical_personality_code)) {
      params.company.juridical_personality_code =
        formValues.juridical_personality_code;
    }
    FieldTreesApi.createWithCompany(fieldId, params)
      .then(response => {
        if (response.result) {
          this.setState({ showConfirmDialog: false }, () => {
            const fieldTree = _.get(response, 'data.entities.field_tree');
            dialogLoader.show(AddPartnerCompanyFieldTreeSuccessDialog, {
              companyName: fieldTree.company_name,
              onConfirm: () => {
                dialogLoader.close();
                masterSlideLoader.show('PartnerBox', {
                  state: { id: fieldTree.id },
                });
              },
              onCancel: () => {
                dialogLoader.close();
                EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
                masterSlideLoader.show(
                  'FieldTreePage',
                  { state: { id: 1 } },
                  this.props.vw
                );
                EventMg.trigger(FIELD_TREE_EVENTS.BACK_TO_MAIN, {
                  update: true,
                });
              },
            });
          });
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  showErrorDialog = errorMessage => {
    this.handleVisibleDialog(true);
    this.setState({ errorMessage });
  };

  handleVisibleDialog = visibleDialogFlag => {
    this.setState({ visibleDialogFlag });
  };

  handleDeleteCompany = async fieldTreeId => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await api.checkPartnerReportsCreated(
      this.props.fieldId,
      fieldTreeId
    );
    this.isSubmitingFlag = false;
    dialogLoader.close();
    if (response.result) {
      if (_.get(response, 'data.entities.is_partner_reports_created')) {
        this.setState({
          visiblePartnerReportsCreatedConfirmDialog: true,
        });
        return;
      }
      this.runDeleteCompany(fieldTreeId);
    } else {
      this.setState({
        visibleCheckPartnerReportsCreatedErrorDialog: true,
      });
    }
  };

  runDeleteCompany = async (
    fieldTreeId,
    isClosePartnerReportsCreatedConfirmDialog = false
  ) => {
    const result = await this.deleteCompany(fieldTreeId);
    if (isClosePartnerReportsCreatedConfirmDialog) {
      this.setState({ visiblePartnerReportsCreatedConfirmDialog: false });
    }
    if (result) {
      EventMg.trigger(FIELD_TREE_EVENTS.COMPANY_DELETE_SUCCESS, this.fieldTree);
      EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
    }
  };

  setHasPartners = flag => {
    this.setState({ hasPartners: flag });
  };

  render() {
    return (
      <React.Fragment>
        <Information
          message={this.state.errorMessage}
          buttonText={messageUtility.getMessage('I-000-011')}
          visible={this.state.visibleDialogFlag}
          onClose={() => this.handleVisibleDialog(false)}
        />
        <table className='fieldstree-as-sticky-table'>
          <thead>
            <tr>
              <th>
                <FieldTreeLabel
                  ccusInfo={this.props.ccusInfo}
                  tree={this.props.tree}
                  setHasPartners={this.setHasPartners}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                ref='tree'
                className='fieldstree-tree'
                onClick={e => {
                  EventMg.trigger(FIELD_TREE_EVENTS.TREE_CLICK_OUTSIDE_TREE, e);
                }}
              >
                {_.map(this.sortCompany(this.props.tree), (nodes, index) => {
                  return this.generateBlock(nodes, `${this.path}-${index}`);
                })}
              </td>
            </tr>
          </tbody>
        </table>
        <Modal modalRoot='root' modalState={this.state.showModal}>
          <DialogSuccessError
            msg={this.state.updateMsg}
            updateSuccess={this.state.updateSuccess}
            success={() => this.setState({ showModal: false })}
            error={() => this.setState({ showModal: false })}
          />
        </Modal>
        <Information
          visible={this.state.visibleCheckPartnerReportsCreatedErrorDialog}
          title={messageUtility.getMessage('E-001-402')}
          message={messageUtility.getMessage('E-000-055')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() =>
            this.setState({
              visibleCheckPartnerReportsCreatedErrorDialog: false,
            })
          }
          multilineText={true}
        />
        <Confirmation
          visible={this.state.visiblePartnerReportsCreatedConfirmDialog}
          title='労務安全書類が存在します'
          message={messageUtility.getMessage('W-000-006')}
          confirmButtonText='削除する'
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={() => this.runDeleteCompany(this.fieldTree.id, true)}
          onCancel={() => {
            this.setState({ visiblePartnerReportsCreatedConfirmDialog: false });
          }}
          isNegative={true}
          multilineText={true}
          rootClassName='dialog--wide'
        />
      </React.Fragment>
    );
  }
}

export default class FieldTreeMain extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tree: [],
      jvflag: false,
      constructor: {},
    };
    this.fieldTreeMainRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.state.tree) !== JSON.stringify(nextProps.tree)) {
      let _tree = _.cloneDeep(nextProps.tree);
      if (_tree.length > 0) {
        _tree[0].children = [];
      }
      this.setState({ tree: _tree });
    }
  }

  shouldComponentUpdate(nextProps) {
    return this.props.isShowForm === nextProps.isShowForm;
  }

  handleScrollFieldTreeMain = heightScrollDown => {
    this.fieldTreeMainRef.current.scrollBy({
      top: heightScrollDown,
      behavior: 'smooth',
    });
  };

  render() {
    return (
      <div className='fieldstree-main__tree' ref={this.fieldTreeMainRef}>
        <FieldTree
          tree={this.state.tree}
          constructor={this.props.constructor}
          callback={this.callback}
          vw={this.props.vw}
          fieldId={this.props.fieldId}
          login_user_contractor={this.props.login_user_contractor}
          isCcusDisplayStateFlg={this.props.isCcusDisplayStateFlg}
          autoTaskActive={this.props.autoTaskActive}
          cacheParam={this.props.cacheParam}
          nodes={this.props.nodes}
          selectedNodes={this.props.selectedNodes}
          ccusInfo={this.props.ccusInfo}
          resetSelectedPartnerCompanyBranch={
            this.props.resetSelectedPartnerCompanyBranch
          }
          scrollFieldTreeMain={this.handleScrollFieldTreeMain}
        />
        {this.props.isLoading && <div className='indicator' />}
        <div
          className={
            this.props.lastPage === 0
              ? 'footer-pagination has-no-children'
              : 'footer-pagination'
          }
        >
          <FieldTreePagination
            page={this.props.page}
            lastPage={this.props.lastPage}
          />
        </div>
      </div>
    );
  }
}

/**
 * 登録完了
 */
export class SubmitSuccess extends React.Component {
  render() {
    return (
      <div
        className='dialog-sm dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-sm__header'>
          <span className='dialog-sm__title'>登録完了</span>
        </div>
        <div className='dialog-sm__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}

const FieldTreeCcusConnection = ({
  isCcusStateActiveFlg,
  isBeforeCcusConnectionFlg,
  isCcusProcessingFlg,
  canAccessCcus,
  fieldConnectionStatus,
  autoTaskActive,
  messageCcus,
  tree,
  action,
  mainJvCcusSecededFlag,
}) => {
  const handleToggleCcusStatus = () => {
    EventMg.trigger(FIELD_TREE_EVENTS.TOGGLE_CCUS_STATES);
  };

  const renderSwitchStateCcus = () => {
    if (!isBeforeCcusConnectionFlg) {
      return (
        <Switch
          label='連携表示：'
          switchTextArray={['ON', 'OFF']}
          handleToggle={handleToggleCcusStatus}
          checked={isCcusStateActiveFlg}
        />
      );
    } else {
      return null;
    }
  };

  const renderToolTip = () => {
    return (
      <div>
        <Tippy
          className='tooltip'
          duration={10}
          distance={24}
          arrow='true'
          arrowType='sharp'
          delay={[100, 100]}
          placement='bottom'
          followCursor={true}
          html={
            <div className='tippy-tooltip'>
              施工体制情報と施工体制作業員情報がBuildeeからCCUSに連携されます。
              <br />
              CCUSで施工体制情報や施工体制作業員情報を登録する必要はありません。
            </div>
          }
        >
          <QuestionIcon className='icon--2_4x question-icon' />
        </Tippy>
      </div>
    );
  };

  const renderButtonCcus = () => {
    if (!canAccessCcus) {
      return null;
    }
    return (
      <button
        className={
          isCcusProcessingFlg || mainJvCcusSecededFlag
            ? 'btn btn-primary btn-ccus btn--disabled'
            : 'btn btn-primary btn-ccus'
        }
        onClick={action.ccusFieldTree}
      >
        今すぐCCUSに連携
      </button>
    );
  };

  if (
    _.isNil(autoTaskActive) ||
    _.isNil(fieldConnectionStatus) ||
    !fieldConnectionStatus ||
    _.isEmpty(tree)
  ) {
    return null;
  }

  return (
    <div className='FieldTreeCcusConnection-wrapper'>
      {renderSwitchStateCcus()}
      {isCcusStateActiveFlg && (
        <div className='FieldTreeCcusConnection'>
          <div className='FieldTreeCcusConnection__status-on'>
            <div className='FieldTreeCcusConnection__header'>
              <span className='FieldTreeCcusConnection__header--title'>
                CCUSとの施工体制連携
              </span>
              {renderToolTip()}
              {renderButtonCcus()}
            </div>
            <div className='FieldTreeCcusConnection__content'>
              <div
                className={
                  mainJvCcusSecededFlag
                    ? 'text-description text--negative'
                    : 'text-description'
                }
              >
                {messageCcus}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/FieldTreeMain.jsx